const AbortIcon: React.FC = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.722657 0.722656L16.7917 16.7917M16.7917 0.722656L0.722656 16.7917"
                stroke="white"
                stroke-width="1.44622"
                stroke-linecap="round"
            />
        </svg>
    )
}

AbortIcon.displayName = 'AbortIcon'

export default AbortIcon
